import { cn } from '@/libs/utils';

export default function AnimateDot({ show, className, showClassName }) {
  return (
    <span className="relative flex h-2.5 w-2.5">
      {show && (
        <span
          className={cn(
            'absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-75',
            showClassName
          )}
        />
      )}

      <span
        className={cn(
          'relative inline-flex h-2.5 w-2.5 rounded-full bg-accent',
          show ? 'bg-accent' : 'bg-zinc-200',
          className
        )}
      />
    </span>
  );
}
